import React, { Component } from 'react';
import DesktopProductCarouselV2 from "../DesktopProductCarouselV2/DesktopProductCarouselV2.js";
import H3Subtitle from '../H3Subtitle/H3Subtitle.js';
import Spinner from '../Spinner/Spinner.js';

class CarouselManagerAppV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            suitesData: {},
            domainId: '',
            blockTitle: ''

        };

        this.fetchHomepageData = this._fetchHomepageData.bind(this);
    }

    componentWillMount() {
        this.fetchHomepageData(); // when components mount then fetch data.
    }

    render() {

        return (
            <div id="courseTilesBlockComponent" className={this.state.isLoading ? 'carousel--loading' : 'carousel--loaded'}>
                <Spinner isLoading={this.state.isLoading}></Spinner>
                <H3Subtitle
                    titleClass={this.props.blockTitleClass}
                    titleText={this.state.blockTitle}
                />
                {this.state.suitesData.length > 0 ?
                    <React.Fragment>
                        <div className="slick-slider__wrapper">

                            <DesktopProductCarouselV2
                                data={this.state.suitesData}
                                route={this.props.route}
                                domainId={this.state.domainId}
                            />

                        </div>
                        <div className="row">
                            <span className="rule--solid"></span>
                        </div>
                    </React.Fragment>
                    : ''}
            </div>
        );
    }

    /**
     * @method _fetchHomepageData - Retrieves the suites data for the home page via the Course API.
     */
    async _fetchHomepageData() {
        try {
            let homePageSuitesData = { data: [], api:{} };
            if (typeof this.props.data === 'function') { // check the props type for 'function' to make api call
                homePageSuitesData = await this.props.data(1, 25);
            } else { // otherwise take the data directly - as is.
                homePageSuitesData.data = this.props.data ? this.props.data : {};
            }
            this.setState({ suitesData: homePageSuitesData.data.suites ? homePageSuitesData.data.suites.data : '' });
            this.setState({ domainId: homePageSuitesData.data.suites.api ? homePageSuitesData.data.suites.api.domain_id : '' });
            this.setState({ blockTitle: this.props.blockTitle });
            this.setState({ isLoading: false });
        } catch (error) {
            console.error(error);
        }
    }
}

export default CarouselManagerAppV2;